<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {createEventDispatcher} from 'svelte/internal';
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let account = null;

    const dispatch = createEventDispatcher();

    const onCreate = () => {
        dispatch('create');
    }

    const onEdit = (obj) => {
        dispatch('edit', obj.id);
    }

    const onDelete = (obj) => {
        Alert.delete("Delete department", `This will permanently delete department "${obj.name}".\nAre you sure?`, () => deleteDepartment(obj.id));
    }

    const deleteDepartment = (id) => {
        const onSuccess = result => {
            account.departments = account.departments.filter(x => x.id !== result);
            Notifier.showMessage("Department deleted");
        }

        const onFailure = err => {
        };

        R.handle(R.department.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading py-2">
        Departments
        <button class="btn btn-primary btn-sm" on:click="{ onCreate }" disabled="{ account.id == 0 }">
            CREATE DEPARTMENT
        </button>
    </div>
    {#if account.id > 0}
        {#if account.departments.length}
            <table class="table table-list">
                <tbody>
                {#each account.departments as item}
                    <tr class="row-hover">
                        <td>
                            <ColoredNameControl name="{ item.name }"
                                                color="{ item.color }"
                                                colorName isLink
                                                isActive="{ item.is_active  }"
                                                on:click="{ () => onEdit(item) }"
                            />
                        </td>
                        <td class="button-column pointer" title="delete department" on:click="{ () => onDelete(item) }">
                            <AppIcon icon="trash" size="16"/>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        {:else}
            <div class="panel-body panel-pad">
                Account has no departments yet.
            </div>
        {/if}
    {:else}
        <div class="panel-body panel-pad">
            Save new account in order to add departments
        </div>
    {/if}
</div>